export default {
  "nav.thesis": "الأطروحة",
  "nav.disciplines": "التخصصات",
  "nav.horizon": "الأفق",
  "nav.join": "قدّم طلبك",
  "nav.backus": "اشترك",
  "nav.invest": "ادعمنا",

  "hero.badge": "هندسة طول العمر",
  "hero.l1": "الخلود البشري نظريّ.",
  "hero.l2": "150 عامًا أمر عملي.",
  "hero.sub": "طول العمر تحدٍ إنساني متعدد التخصصات. لقد قاد الطب والعلوم الصحية تقدمًا ملحوظًا في طول العمر. وقد تأتي الاكتشافات القادمة من تقاربها مع الهندسة والذكاء الاصطناعي وعلم الأعصاب وعلم النفس والعلوم المعرفية وميكانيكا الكم وفيزياء الجسيمات والزمكان.",
  "hero.sub2": "يجمع مشروع ذا لايف سبان هذه التخصصات معًا. لا يبدو أن شيئًا في قوانين الفيزياء المعروفة يمنع حياة بشرية أطول بكثير. ونعتزم البحث وإثبات ما هو ممكن.",
  "hero.cta1": "اشترك في المشروع",
  "hero.cta2": "اقرأ الأطروحة",
  "hero.stats1": "09 تخصصات",
  "hero.stats2": "نطاق دون الحسّ",
  "hero.stats3": "أول الحلول ≤ 24 شهرًا",
  "hero.caption": "بحث على نطاق دون الحسّ قيد التنفيذ",

  "mq.1": "الزمكان",
  "mq.2": "فيزياء الجسيمات",
  "mq.3": "ميكانيكا الكم",
  "mq.4": "حوسبة الذكاء الاصطناعي",
  "mq.5": "علم الأحياء",
  "mq.6": "علم الأعصاب",
  "mq.7": "علم النفس",
  "mq.8": "العلوم المعرفية",
  "mq.11": "العلوم الصحية",
  "mq.12": "العلوم الطبية",
  "mq.9": "طول العمر",
  "mq.10": "150+ عامًا",

  "mani.eyebrow": "البيان",
  "mani.h2a": "الموت هو أقدم",
  "mani.h2b": "مشكلة لم تُحل",
  "mani.h2c": "في الفيزياء.",
  "mani.c1t": "الأطروحة",
  "mani.c1b": "الشيخوخة ليست قانونًا من قوانين الطبيعة؛ بل هي مشكلة هندسية لم تُحل بعد. نحن نؤمن إيمانًا راسخًا بأن الإنسان يمكن أن يبلغ الخلود نظريًا، وعمرًا يتجاوز 150 عامًا عمليًا، في المستقبل القريب. كل تخصص نلمسه يشير إلى الاتجاه نفسه.",
  "mani.c2t": "المنهج",
  "mani.c2b": "تعمل برامجنا البحثية والحوسبية على نطاق دون الحسّ: تحت الضجيج، عبر كامل منظومة المادة والعقل. من تفاعلات الجسيمات إلى الحوسبة العصبية، نمذج الحياة كنظام يمكن فهمه ومحاكاته وإطالته.",
  "mani.c3t": "الأفق",
  "mani.c3b": "هذا ليس مشروعًا يمتد قرنًا. خلال العامين المقبلين سنطلق حلولنا الأولى؛ وهي أولى نواتج برنامج أكبر بكثير. وما يأتي بعد ذلك يتراكم.",
  "mani.c4t": "النموذج",
  "mani.c4b": "يُموَّل بحثنا عبر منظومة واسعة: الداعمون والمستثمرون والمشتركون الأكاديميون والمحسنون وكبار المستثمرين ورواد الأعمال والشركات المساعِدة والرعاة. تتدفق المنتجات والخدمات عبر The Lifespan Labs لإبقاء البحث متحركًا؛ فهي المحرك، وليست الغاية أبدًا.",

  "disc.eyebrow": "المنظومة",
  "disc.h2a": "تسعة تخصصات.",
  "disc.more": "كيف تتقارب",
  "disc.converge": "الطب × الفيزياء × طول العمر",
  "disc.h2b": "متغير واحد.",
  "disc.sub": "طول العمر ليس مشكلة بيولوجية فحسب. إنه مشكلة منظومة كاملة، من الجسيمات إلى الوعي.",
  "disc.d1n": "الزمكان والمادة",
  "disc.d1d": "الحياة تتكشف داخل نسيج فيزيائي. ندرس كيف تتنظم المادة وتستمر وتُصلح نفسها عبر الزمن.",
  "disc.d1x": "يقيس الطب الشيخوخة بالسنوات؛ أما الفيزياء فتسأل ما هو الزمن ذاته. وبدراسة كيفية تنظيم المادة واستمرارها عبر الزمكان، نبحث عن أعمق الرافعات التي تتيح للأنظمة الحية مقاومة التدهور.",
  "disc.d2n": "فيزياء الجسيمات",
  "disc.d2d": "عند أصغر المقاييس تكمن القواعد التي يتبعها كل شيء آخر.",
  "disc.d2x": "كل دواء وخلية وفكرة مبنية من جسيمات تتبع قواعد دقيقة. وفهم تلك القواعد عند أصغر المقاييس يتيح للطب تصميم تدخلات بدقة ذرية بدلًا من التقريب.",
  "disc.d3n": "ميكانيكا الكم",
  "disc.d3d": "الترابط والتفكك والأساس الكمي للآلية البيولوجية.",
  "disc.d3x": "الحياة تعمل بالفعل بآليات كمومية: الإنزيمات والتمثيل الضوئي وربما الإدراك. وحيث يلتقي الطب بفيزياء الكم، نستكشف الترابط والنفق الكمومي والاستشعار كأدوات جديدة لقراءة البيولوجيا وإصلاحها.",
  "disc.d4n": "الذكاء الاصطناعي والحوسبة",
  "disc.d4d": "المحاكاة والذكاء الآلي يختصران عقودًا من التجارب البيولوجية في أيام من الحوسبة.",
  "disc.d4x": "يضغط الذكاء الاصطناعي عقودًا من التجربة والخطأ الطبي في أيام من المحاكاة. وبالاقتران مع نماذج فيزيائية للجسم، يتيح لنا اختبار الجزيئات والعلاجات حاسوبيًا قبل أن تصل إلى أي مريض.",
  "disc.d5n": "علم الأحياء",
  "disc.d5d": "إصلاح الخلايا والشيخوخة الخلوية والتجدد: رافعات طول العمر المباشرة.",
  "disc.d5x": "تمنح البيولوجيا الطب أهدافه: إصلاح الخلايا والشيخوخة الخلوية والتجدد. وبالاقتران مع قياسات بدقة فيزيائية، يتحول التقدم في العمر من لغز إلى مواصفة هندسية.",
  "disc.d6n": "علم الأعصاب",
  "disc.d6d": "الدماغ هو النواة التي لا تُعوَّض. حمايته وإطالته أمر غير قابل للتفاوض.",
  "disc.d6x": "الدماغ هو حيث لا يستطيع الطب حتى الآن استبدال ما يتعطل. ويتقارب علم الأعصاب مع الفيزياء والحوسبة لحماية جوهر ما نحن عليه الذي لا يُستبدل، والتواصل معه، ويومًا ما تمديده.",
  "disc.d7n": "علم النفس والعلوم المعرفية",
  "disc.d7d": "الحياة الأطول يجب أن تبقى حياة تستحق العيش: العقل والذاكرة والمعنى مشمولة.",
  "disc.d7x": "لا قيمة لحياة أطول إلا إذا ازدهر العقل. ترسم العلوم المعرفية والطب معًا خريطة كيفية تغير الذاكرة والدافع والمعنى مع التقدم في العمر، لتبقى السنوات المضافة جديرة بأن تُعاش.",
  "disc.d8n": "العلوم الصحية",
  "disc.d8d": "الصحة العامة والتغذية والوقاية، رافعات على مستوى السكان أضافت بالفعل عقودًا إلى حياة الإنسان.",
  "disc.d8x": "أضافت الصحة العامة عقودًا إلى حياة الإنسان دون حبة دواء واحدة: الصرف الصحي والتغذية والوقاية. وبقياسها بدقة فيزيائية، تصبح رافعات السكان هذه بنية تحتية قابلة للبرمجة من أجل طول العمر.",
  "disc.d9n": "العلوم الطبية",
  "disc.d9d": "يحوّل الطب السريري أبحاث طول العمر إلى ممارسة: تشخيصات وعلاجات ورعاية تطيل سنوات الصحة.",
  "disc.d9x": "يحوّل الطب كل اكتشاف إلى ممارسة. وبالتقارب مع الفيزياء والهندسة، تكتسب التشخيصات والتصوير والعلاجات الدقة اللازمة لرصد الشيخوخة مبكرًا وعكسها بدقة.",

  "time.eyebrow": "الأفق",
  "time.h2a": "عامان حتى",
  "time.h2b": "أول الحلول.",
  "time.m1t": "الآن",
  "time.m1h": "بحث على نطاق دون الحسّ",
  "time.m1b": "برامج بحثية وحوسبية عميقة واسعة النطاق تجري الآن، بهدوء، بعيدًا عن الأنظار، عبر الفيزياء والذكاء الاصطناعي وعلم الأحياء.",
  "time.m2t": "T + 12 شهرًا",
  "time.m2h": "أولى التدخلات المرشحة",
  "time.m2b": "أقدم نواتج البرنامج المُصدَّقة تنتقل من المحاكاة إلى التقييم المنظم.",
  "time.m3t": "T + 24 شهرًا",
  "time.m3h": "إطلاق أول الحلول",
  "time.m3b": "حلولنا الأولى تصدر. بداية سلسلة متراكمة نحو إطالة جذرية لعمر الإنسان.",
  "time.outro": "ترقبوا. الساعة تدق بالفعل.",

  "pipe.eyebrow": "المسار",
  "pipe.h2a": "من البحث الأساسي إلى",
  "pipe.h2b": "حلول العالم الحقيقي.",
  "pipe.s1t": "البحث الأساسي",
  "pipe.s1tail": "والتخصصات ذات الصلة.",
  "pipe.s2t": "النماذج والاكتشاف",
  "pipe.s3t": "التقنية",
  "pipe.s4t": "The Lifespan Labs",
  "pipe.s4d": "منظومة منتقاة من المنتجات والخدمات الداعمة لحياة أصح وأطول وأفضل.",
  "pipe.s5t": "منظومة الحياة الأطول",
  "pipe.s5tail": "وحلول موجهة نحو طول العمر.",

  "back.eyebrow": "البرنامج",
  "back.h2a": "أولًا،",
  "back.h2b": "معادلة الخلود.",
  "back.h2c": "ثم كل ما تفتحه.",
  "back.badge": "البرهان قبل المنتج",
  "back.copy": "عملنا الجوهري رياضي: برهان مبني على الفيزياء، معادلة الخلود، يُضفي الطابع الرسمي على لماذا يمكن إيقاف الزمن البيولوجي وعكسه. كل حل نبنيه ينبع منها.",
  "back.cta1": "اشترك في المشروع",
  "back.cta2": "ادعمنا",

  "sub.eyebrow": "ابقَ قريبًا من البحث",
  "sub.h2a": "اشترك في التحديثات.",
  "sub.h2b": "انضم إلى المجتمع.",
  "sub.p": "أخبار البحث والمنشورات وتحديثات المنظومة، مباشرة إلى بريدك. كل مشترك جديد يُرحَّب به ببطاقة عضوية رقمية كعضو Prime، مع الشهر الأول مجانًا.",
  "sub.success.h": "مرحبًا بك في المجتمع.",
  "sub.success.p": "بطاقة عضويتك الرقمية كعضو Prime بالأسفل، ونسخة في طريقها إلى بريدك، مع شهرك الأول مجانًا.",
  "sub.download": "تنزيل بطاقة العضوية",
  "sub.submit": "اشترك في التحديثات",
  "sub.sending": "جارٍ الاشتراك...",

  "form.name": "الاسم الكامل",
  "form.email": "البريد الإلكتروني",
  "form.phone": "رقم الاتصال",
  "form.country": "الدولة",
  "form.city": "المدينة",
  "form.ph.name": "اسمك",
  "form.ph.country": "الهند",
  "form.ph.city": "مومباي",
  "form.error": "حدث خطأ ما. حاول مجددًا أو راسل invest@thelifespanproject.com.",
  "form.sending": "جارٍ الإرسال...",

  "footer.desc": "مبادرة بحثية متعددة التخصصات لطول العمر البشري، نهندس بها الأعوام الـ150 المقبلة من حياة الإنسان.",
  "footer.explore": "استكشف",
  "footer.contact": "اتصل بنا",
  "footer.legal": "قانوني",
  "footer.terms": "الشروط",
  "footer.privacy": "سياسة الخصوصية",
  "footer.refund": "سياسة الاسترداد",
  "footer.faq": "الأسئلة الشائعة",
  "footer.partners": "الشركاء التقنيون والداعمون",
  "footer.copyright": "© 2026 The Lifespan Project. جميع الحقوق محفوظة.",
  "footer.tagline": "الخلود نظريّ. 150 عامًا أمر عملي.",

  "pick.title": "اختر طريقة العرض",
  "pick.sub": "اختر سمة للبدء. يمكنك التبديل في أي وقت من الترويسة.",
  "pick.dark": "داكن",
  "pick.dark.sub": "سينمائي",
  "pick.light": "فاتح",
  "pick.light.sub": "أبيض متدرج",

  "cookie.text": "يستخدم هذا الموقع ملفات تعريف ارتباط أساسية وتحليلات تحترم الخصوصية. بالمتابعة، فأنت تقر بـ",
  "cookie.accept": "فهمت",

  "inv.badge": "علاقات المستثمرين",
  "inv.h1a": "استثمر في",
  "inv.h1b": "الأعوام الـ150 المقبلة.",
  "inv.sub": "The Lifespan Project مبادرة بحثية متعددة التخصصات لطول العمر البشري. أخبرنا من أنت وسيتواصل معك فريقنا بملف المستثمر الكامل.",
  "inv.perks.h": "ما يحصل عليه المستثمرون",
  "inv.perk1": "ملف المستثمر الكامل وخارطة طريق البحث",
  "inv.perk2": "خط مباشر مع الفريق المؤسس",
  "inv.perk3": "غرفة بيانات ووثائق تقنية عند الطلب",
  "inv.perk4": "اطلاع مبكر على مسار الحلول",
  "inv.next.h": "ماذا بعد",
  "inv.next.p": "ستتلقى فورًا إشعارًا بهوية المشروع مع نسخة من استفسارك. ثم يتواصل معك فريقنا شخصيًا بملف المستثمر. تفضل البريد؟ اكتب إلى",
  "inv.org": "المنظمة",
  "inv.ph.org": "صندوق أو مؤسسة أو شركة",
  "inv.interest": "مجال اهتمامك",
  "inv.ph.interest": "حجم الاستثمار، التفويض، الإطار الزمني...",
  "inv.submit": "اطلب ملف المستثمر",
  "inv.success.h": "شكرًا لك، تم استلام الطلب.",
  "inv.success.p": "إشعار بهوية المشروع مع نسخة من استفسارك في طريقه إلى بريدك. سيتواصل معك فريقنا قريبًا.",

  "join.badge": "تعاون معنا",
  "join.h1a": "انضم إلى المختبر",
  "join.h1b": "كمتعاون.",
  "join.sub": "نعمل مع باحثين وأطباء ومحترفين استثنائيين كمتدربين ومتعاونين، على معادلة الخلود وكل ما تفتحه.",
  "join.elig.h": "الحد الأدنى من الأهلية",
  "join.elig1": "دكتوراه أو PhD أو MBBS أو MD",
  "join.elig2": "أو دراسات عليا بتخصصين في أي مجال",
  "join.elig3": "يعمل حاليًا كمحترف، في أي مكان",
  "join.elig4": "خبرة 5 سنوات على الأقل، في الهند أو خارجها",
  "join.next.h": "ماذا بعد",
  "join.next.p": "كل طلب يُراجَع شخصيًا من فريقنا البحثي. ستتلقى فورًا نسخة بريدية من طلبك، ونتواصل معك عند وجود توافق.",
  "join.qual": "أعلى مؤهل",
  "join.qual.select": "اختر المؤهل",
  "join.disc": "ما التخصص الأنسب لك؟",
  "join.disc.select": "اختر تخصصًا",
  "join.disc.unsure": "لست متأكدًا بعد",
  "join.spec": "التخصص / المجال",
  "join.ph.spec": "مثال: علم الأحياء الكمي، علم الأعصاب",
  "join.exp": "سنوات الخبرة",
  "join.ph.exp": "5 كحد أدنى",
  "join.role": "الدور الحالي والمنظمة",
  "join.ph.role": "مثال: عالم أبحاث، CSIR",
  "join.why": "لماذا تريد التعاون؟",
  "join.ph.why": "اهتماماتك البحثية، منشوراتك، ما الذي ستعمل عليه...",
  "join.ph.country": "الهند / خارجها",
  "join.submit": "قدّم كمتعاون",
  "join.submitting": "جارٍ الإرسال...",
  "join.success.h": "تم استلام الطلب.",
  "join.success.p": "نسخة من طلبك في طريقها إلى بريدك. فريقنا البحثي يراجع كل طلب شخصيًا.",

  "bu.badge": "ندفع علم طول العمر البشري قدمًا",
  "bu.h1a": "كن",
  "bu.h1b": "عضوًا مؤسسًا",
  "bu.h1c": "في The Lifespan Project.",
  "bu.sub": "مستقبل طول العمر البشري لن تبنيه تخصص واحد أو مختبر واحد أو تقنية واحدة. سيُبنى عبر البحث والتجريب والتعاون وترجمة المعرفة العلمية إلى حلول ملموسة. عضويتك تساعد في دعم هذه المسيرة.",
  "bu.projline": ": يبحث في العلم.",
  "bu.labsline": ": يحيي حلول طول العمر.",

  "arch.eyebrow": "البنية",
  "arch.h2a": "مهمة واحدة.",
  "arch.h2b": "محركان.",
  "arch.proj.h": "بحث وتطوير علمي",
  "arch.labs.h": "سوق طول العمر",

  "flow.1": "البحث",
  "flow.2": "التحقق",
  "flow.3": "التقنية",
  "flow.4": "المنتجات والخدمات",
  "flow.5": "حياة أطول وأصح",

  "pos.eyebrow": "ماذا تعني العضوية",
  "pos.h2": "أنت لا تشترك ببساطة في محتوى.",
  "pos.p": "أنت تصبح جزءًا من المجتمع المؤسس وراء البحث. تدعم العضوية التطوير المستمر للبحث والعمل العلمي والمعرفة والتجريب ومسار الحلول المستقبلي لـ The Lifespan Project. وفي المقابل، يحصل الأعضاء المؤسسون على عضوية رقمية تربطهم بمنظومة Lifespan المتنامية.",
  "pos.note": "العضوية لا تضمن أي نتيجة علمية أو نتيجة صحية أو زيادة في العمر.",

  "eco.eyebrow": "العضوية الرقمية للمؤسسين",
  "eco.h2a": "عضويتك تمتد",
  "eco.h2b": "إلى ما وراء البحث.",
  "eco.sub": "كل عضو مؤسس يحصل على عضوية رقمية في منظومة Lifespan المتنامية، بما فيها الوصول إلى سوق The Lifespan Labs القادم.",
  "eco.c1n": "الصحة",
  "eco.c2n": "الغذاء والتغذية",
  "eco.c3n": "المؤشرات الحيوية والمختبرات",
  "eco.c4n": "الأطباء والخدمات الصحية",
  "eco.c5n": "الأجهزة والآلات",
  "eco.c6n": "الرياضة والجسم",
  "eco.c7n": "الشفاء والعلاج الطبيعي",
  "eco.c8n": "العقل وعلم النفس",
  "eco.c9n": "العقل · الجسم · الروح",

  "ben.eyebrow": "مزايا العضو المؤسس",
  "ben.h": "ما يحصل عليه الأعضاء المؤسسون",

  "mode.free": "مجاني",
  "mode.monthly": "شهري",
  "mode.life": "مدى الحياة",
  "cad.month": "شهريًا",
  "cad.life": "مدى الحياة",
  "cad.free": "للأبد",
  "cad.month.short": "شهر",
  "reg.intl": "خارج الهند",
  "reg.in": "الهند",

  "plan.prime.tag": "بوابة الدخول إلى منظومة Lifespan.",
  "plan.prime.f1": "بطاقة عضوية رقمية للمؤسسين برمز قابل للمسح",
  "plan.prime.f2": "كل الأبحاث والمحتوى والفيديوهات المنشورة",
  "plan.prime.f3": "الوصول إلى The Lifespan Labs عند الإطلاق",
  "plan.prime.f4": "عروض الأعضاء والأسعار التفضيلية",
  "plan.prime.f5": "قدّم بحثك للنظر فيه بمراجعة الأقران",
  "plan.pro.tag": "كل ما في Prime، مدى الحياة. إضافة إلى الدائرة الداخلية.",
  "plan.pro.f1": "عضوية مدى الحياة، بلا تجديدات",
  "plan.pro.f2": "إصدارات بحثية وحصريات للأعضاء Pro فقط",
  "plan.pro.f3": "دعوات لاجتماعات وفعاليات بحثية حول العالم",
  "plan.pro.f4": "خصومات معززة عبر The Lifespan Labs",
  "plan.pro.f5": "أولوية الوصول إلى المنتجات والخدمات الجديدة",
  "plan.well.tag": "ابقَ قريبًا من العلم، دون تكلفة.",
  "plan.well.f1": "بطاقة عضوية Wellwisher رقمية برمز",
  "plan.well.f2": "أخبار البحث وتحديثاته",
  "plan.well.f3": "أول من يعرف بإطلاق The Lifespan Labs",

  "cta.subscribe": "اشترك هنا",
  "cta.free": "اشترك مجانًا",
  "cta.welllink": "اشترك مجانًا كعضو Wellwisher",

  "why.eyebrow": "السبب",
  "why.h": "لماذا تصبح عضوًا مؤسسًا؟",
  "why.1t": "ادعم البحث",
  "why.2t": "ادخل المنظومة",
  "why.3t": "اكتشف ما هو قادم",
  "why.4t": "ساعد في صياغة المستقبل",

  "flowS.eyebrow": "كيف يترابط كل هذا",
  "flowS.h": "من البحث إلى المجتمع",
  "flowS.n1t": "بحث وتطوير · علم · بحث · تقنية",
  "flowS.n2t": "منتجات · خدمات · سوق · وصول",
  "flowS.n3t": "مجتمع · وصول · مشاركة",
  "flowS.proline": "قد يتلقى الأعضاء المؤسسون Pro دعوات إلى اجتماعات بحثية ومؤتمرات وفعاليات منظومة Lifespan Project المختارة حول العالم.",
  "net.caption": "شبكة البحث العالمية",

  "ck.eyebrow": "كن عضوًا مؤسسًا",
  "ck.h": "فعّل عضويتك",
  "ck.submit": "تابع إلى الدفع الآمن",
  "ck.sending": "جارٍ فتح الدفع الآمن...",
  "ck.per.month": " / شهريًا",
  "ck.per.life": " مدى الحياة",
  "ck.note1": "مسجل كاشتراك",
  "ck.note2": ". الإيصال والفاتورة الضريبية يلحقان بالبريد.",
  "ck.invite.toggle": "هل لديك رمز دعوة؟",
  "ck.invite.code": "رمز الدعوة",
  "ck.invite.sending": "جارٍ تطبيق دعوتك...",
  "ck.invite.submit": "استبدال العضوية المجانية",
  "ck.invite.note": "رمز الدعوة الصالح يجعل الخطة المحددة مجانية تمامًا.",
  "ck.invite.ph": "أدخل رمزك",
  "ck.inrnote": "البطاقات الدولية مقبولة. تجري المحاسبة عبر Razorpay بالروبية الهندية بالسعر المعروض.",
  "ck.orwell": "لست مستعدًا بعد لدعم البحث؟",

  "close.h2a": "لا تكتفِ بمشاهدة",
  "close.h2b": "مستقبل طول العمر.",
  "close.h2c": "ساعد في بنائه.",
  "close.p": "The Lifespan Project يبني البحث. وستجمع The Lifespan Labs المنظومة معًا. الأعضاء المؤسسون يساعدون في جعل هذه المسيرة ممكنة، ويصبحون جزءًا مما هو قادم.",
  "close.prime": "كن عضو Prime",
  "close.pro": "كن عضو Pro",
  "close.or": "أو",

  "res.h2a": "لديك فكرة؟",
  "res.h2b": "أحضرها إلى المشروع.",
  "res.cta": "قدّم بحثك",

  "ww.eyebrow": "مجاني للأبد",
  "ww.title": "كن عضو Wellwisher Founding Member",
  "ww.sub": "أخبار البحث وتحديثاته، وبطاقة عضوية Wellwisher الرقمية برمز قابل للمسح، تُسلَّم فورًا.",
  "ww.success.p": "مرحبًا بك. بطاقتك بالأسفل، ونسخة في طريقها إلى بريدك.",
  "ww.submitting": "جارٍ الاشتراك...",

  "legal.notice": "يُقدَّم هذا المستند القانوني بالإنجليزية للحفاظ على معناه الدقيق.",

  "ui.language": "اللغة",
  "ui.theme": "السمة",
};
